import { confirmationDialog } from "src/framework/store/ConfirmationDialogStore";
import { Error } from "@mui/icons-material";

export function showMaxItemsAlert(functionOnclose?: Function, functionOnConfirmation?: Function) {
  confirmationDialog.setup({
    onlyConfirm: true,
    content: ['A quantidade de módulos é insuficiente para atender a necessidade.'],
    size: '440px',
    title: "Atenção!",
    yesText: 'OK',
    propagateWhenConfirm: true,
    subtitle:'',
    onClose: () => {
      if(functionOnclose) functionOnclose();
      confirmationDialog.close();
    },
    onConfirmation: () => {
      if(functionOnConfirmation) functionOnConfirmation();
    },
    headerIcon: <Error style={{ color: '#CC8F00' }} />, 
  })
  confirmationDialog.open();
}